// src/app/services/mbrs/validation-field-value.util.ts
import { buildFieldKey } from './validation-field-key.util';
import { ValidationSchema, ValidationSchemaControl } from '../../models/validation-schema.model';

/**
 * Read a field value from the form bag (same-sheet or cross-sheet).
 * @param resolvedSheetKey caller-resolved sheet key (filing-info alias already translated)
 * @param cachedSchema     the referenced sheet's schema, when available (for calculated/readonly = 0 fallback)
 */
export function getFieldValue(
  formValues: any,
  fieldQname: string,
  resolvedSheetKey?: string,
  cachedSchema?: ValidationSchema
): number | null {
  if (!formValues) {
    return null;
  }

  const value = resolvedSheetKey
    ? formValues[resolvedSheetKey]?.[fieldQname]
    : formValues[fieldQname];

  if (value === null || value === undefined || value === '') {
    if (resolvedSheetKey && cachedSchema) {
      const control = cachedSchema.controls?.find((control: ValidationSchemaControl) => control.qname === fieldQname);
      if (control?.ui?.calculated || control?.ui?.readonly) {
        return 0;
      }
    }
    return null;
  }

  const numValue = Number(value);
  return isNaN(numValue) ? null : numValue;
}

/** Column-aware value lookup (bracket / equity-member key formats). */
export function getFieldValueForColumn(
  formValues: any,
  fieldQname: string,
  resolvedSheetKey: string,
  columnSuffix: string,
  taxonomy: 'MFRS' | 'MPERS',
  cachedSchema?: ValidationSchema
): number | null {
  const sheetData = formValues[resolvedSheetKey];
  const key = buildFieldKey(fieldQname, resolvedSheetKey, columnSuffix, taxonomy);
  const value = sheetData?.[key];

  if (value === null || value === undefined || value === '' || !sheetData || Object.keys(sheetData).length === 0) {
    if (cachedSchema) {
      const control = cachedSchema.controls?.find((control: ValidationSchemaControl) => control.qname === fieldQname);
      if (control?.ui?.calculated || control?.ui?.readonly) {
        return 0;
      }
    }
    return null;
  }
  const numValue = Number(value);
  return isNaN(numValue) ? null : numValue;
}
